import {
  setLiveViewsData,
  setLiveViewDetailData,
  updateLiveViewData,
  deleteLiveViewData,
  createLiveViewData,
} from "stores/slice/bogus/liveViews/const";

const liveViewsConfig = {
  // Get Liveview List — under an MSP
  // GET /ents/{entId}/orgs/{orgId}/sites/{siteId}/settings/liveViews
  "/ents/:entId/orgs/:orgId/sites/:siteId/settings/liveViews.read": {
    protocol: "ws",
    resource: "/ents/:entId/orgs/:orgId/sites/:siteId/settings/liveViews",
    restful: true,
    method: "read",
    buildParams: null,
    action: setLiveViewsData,
    mockSelector: "liveViews",
  },
  // Get Liveview List — standalone organization (not under an MSP)
  // GET /orgs/{orgId}/sites/{siteId}/settings/liveViews
  "/orgs/:orgId/sites/:siteId/settings/liveViews.read": {
    protocol: "ws",
    resource: "/orgs/:orgId/sites/:siteId/settings/liveViews",
    restful: true,
    method: "read",
    buildParams: null,
    action: setLiveViewsData,
    mockSelector: "liveViews",
  },
  // Get Liveview Detail (by view id) — under an MSP
  // GET /ents/{entId}/orgs/{orgId}/sites/{siteId}/settings/liveViews/{liveViewId}
  "/ents/:entId/orgs/:orgId/sites/:siteId/settings/liveViews/:liveViewId.read": {
    protocol: "ws",
    resource: "/ents/:entId/orgs/:orgId/sites/:siteId/settings/liveViews/:liveViewId",
    restful: true,
    method: "read",
    buildParams: null,
    action: setLiveViewDetailData,
    mockSelector: "liveViews.detail",
  },
  // Get Liveview Detail (by view id) — standalone organization (not under an MSP)
  // GET /orgs/{orgId}/sites/{siteId}/settings/liveViews/{liveViewId}
  "/orgs/:orgId/sites/:siteId/settings/liveViews/:liveViewId.read": {
    protocol: "ws",
    resource: "/orgs/:orgId/sites/:siteId/settings/liveViews/:liveViewId",
    restful: true,
    method: "read",
    buildParams: null,
    action: setLiveViewDetailData,
    mockSelector: "liveViews.detail",
  },
  // Update a Liveview Configuration (by view id) — under an MSP
  // PUT /ents/{entId}/orgs/{orgId}/sites/{siteId}/settings/liveViews/{liveViewId}
  "/ents/:entId/orgs/:orgId/sites/:siteId/settings/liveViews/:liveViewId.update": {
    protocol: "ws",
    resource: "/ents/:entId/orgs/:orgId/sites/:siteId/settings/liveViews/:liveViewId",
    restful: true,
    method: "update",
    buildParams: (params) => ({ data: params }),
    action: updateLiveViewData,
    mockSelector: "liveViews.detail",
  },
  // Update a Liveview Configuration (by view id) — standalone organization (not under an MSP)
  // PUT /orgs/{orgId}/sites/{siteId}/settings/liveViews/{liveViewId}
  "/orgs/:orgId/sites/:siteId/settings/liveViews/:liveViewId.update": {
    protocol: "ws",
    resource: "/orgs/:orgId/sites/:siteId/settings/liveViews/:liveViewId",
    restful: true,
    method: "update",
    buildParams: (params) => ({ data: params }),
    action: updateLiveViewData,
    mockSelector: "liveViews.detail",
  },
  // Delete a Liveview Configuration (by view id) — under an MSP
  // DELETE /ents/{entId}/orgs/{orgId}/sites/{siteId}/settings/liveViews/{liveViewId}
  "/ents/:entId/orgs/:orgId/sites/:siteId/settings/liveViews/:liveViewId.delete": {
    protocol: "ws",
    resource: "/ents/:entId/orgs/:orgId/sites/:siteId/settings/liveViews/:liveViewId",
    restful: true,
    method: "delete",
    buildParams: null,
    action: deleteLiveViewData,
    mockSelector: "liveViews",
  },
  // Delete a Liveview Configuration (by view id) — standalone organization (not under an MSP)
  // DELETE /orgs/{orgId}/sites/{siteId}/settings/liveViews/{liveViewId}
  "/orgs/:orgId/sites/:siteId/settings/liveViews/:liveViewId.delete": {
    protocol: "ws",
    resource: "/orgs/:orgId/sites/:siteId/settings/liveViews/:liveViewId",
    restful: true,
    method: "delete",
    buildParams: null,
    action: deleteLiveViewData,
    mockSelector: "liveViews",
  },
  // Create a Liveview Configuration — under an MSP
  // POST /ents/{entId}/orgs/{orgId}/sites/{siteId}/settings/liveViews
  "/ents/:entId/orgs/:orgId/sites/:siteId/settings/liveViews.create": {
    protocol: "ws",
    resource: "/ents/:entId/orgs/:orgId/sites/:siteId/settings/liveViews",
    restful: true,
    method: "create",
    buildParams: (params) => ({ data: params }),
    action: createLiveViewData,
    mockSelector: "liveViews.detail",
  },
  // Create a Liveview Configuration — standalone organization (not under an MSP)
  // POST /orgs/{orgId}/sites/{siteId}/settings/liveViews
  "/orgs/:orgId/sites/:siteId/settings/liveViews.create": {
    protocol: "ws",
    resource: "/orgs/:orgId/sites/:siteId/settings/liveViews",
    restful: true,
    method: "create",
    buildParams: (params) => ({ data: params }),
    action: createLiveViewData,
    mockSelector: "liveViews.detail",
  },
};

export default liveViewsConfig;
